import React, { Component } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment-timezone';

class Badge extends Component {
  static propTypes = {
    badge: PropTypes.object.isRequired,
  };

  render = () => {
    const { badge } = this.props;
    const type = badge.getIn(['course', 'id']) ? 'course' : 'chapter';

    return (
      <div className="badge-comp--wrapper">
        <img src={badge.getIn(['image', 'location'])} alt={`${badge.get('name')} badge`} />
        <div className="badge-details">
          <p className="badge-name">{badge.get('name')}</p>
          <p className="badge-finished">{`Finished ${badge.getIn([type, 'name'])} ${type}`}</p>
          <p className="badge-date">{`Received ${moment(badge.get('_pivot_created_at')).format('MMM DD, YYYY')}`}</p>
        </div>
      </div>
    );
  };
}

export default Badge;



// WEBPACK FOOTER //
// ./src/common/badge/Badge.js